import Plan from '../dataModels/Plan'
import emoji_eyes from '../public/assets/emoji_eyes.png'
import emoji_globe from '../public/assets/emoji_globe.png'
import emoji_ringed_planet from '../public/assets/emoji_ringed_planet.png'
import emoji_telescope from '../public/assets/emoji_telescope.png'
import emoji_tooth from '../public/assets/emoji_tooth.png'

export const FREE_PLAN = new Plan(
  0,
  10,
  'subscription:subscription_plan_free',
  emoji_eyes,
  undefined,
  25
)

export const BASIC_PLAN = new Plan(
  9,
  50,
  'subscription:subscription_plan_basic',
  emoji_telescope,
  process.env.NEXT_PUBLIC_BASIC_PLAN_PRICE_KEY
)

export const BASIC_PLAN_EARLY_ACCESS = new Plan(
  9,
  100,
  'subscription:subscription_plan_basic_early_access',
  emoji_telescope,
  process.env.NEXT_PUBLIC_BASIC_PLAN_EARLY_ACCESS_PRICE_KEY
)

export const REGULAR_PLAN = new Plan(
  39,
  250,
  'subscription:subscription_plan_regular',
  emoji_globe,
  process.env.NEXT_PUBLIC_REGULAR_PLAN_PRICE_KEY
)

export const PRO_PLAN = new Plan(
  139,
  1000,
  'subscription:subscription_plan_pro',
  emoji_ringed_planet,
  process.env.NEXT_PUBLIC_PROFESSIONAL_PLAN_PRICE_KEY
)

export const PRO_PLAN_EARLY_ACCESS = new Plan(
  39,
  1000,
  'subscription:subscription_plan_pro_early_access',

  emoji_globe,
  process.env.NEXT_PUBLIC_PROFESSIONAL_PLAN_EARLY_ACCESS_PRICE_KEY
)
export const COMPANY_PLAN_EARLY_ACCESS = new Plan(
  349,
  10000,
  'subscription:subscription_plan_company_early_access',
  emoji_ringed_planet,
  process.env.NEXT_PUBLIC_COMPANY_PLAN_EARLY_ACCESS_PRICE_KEY
)

export const ADMIN_PLAN = new Plan(
  0,
  100000,
  'subscription:subscription_plan_custom',
  emoji_tooth,
  process.env.NEXT_PUBLIC_ADMIN_PLAN_PRICE_KEY
)

export const CUSTOM_CCM_PLAN = new Plan(
  4500,
  200000,
  'subscription_plan_custom',
  emoji_tooth,
  'price_1LUlcZH6F4Ko54bFoqNRM354'
)

export const TWO_WEEKS = 1000 * 60 * 60 * 24 * 14

export const ALL_PLANS = [
  FREE_PLAN,
  BASIC_PLAN,
  REGULAR_PLAN,
  PRO_PLAN,
  BASIC_PLAN_EARLY_ACCESS,
  PRO_PLAN_EARLY_ACCESS,
  COMPANY_PLAN_EARLY_ACCESS,
  ADMIN_PLAN,
  CUSTOM_CCM_PLAN,
]

export const AVAILABLE_PLANS = [FREE_PLAN, BASIC_PLAN, REGULAR_PLAN, PRO_PLAN]
